import { useEffect, useState } from "react";
import { useFormik } from "formik";
import Select from "react-select";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { customStyles } from "../../utils/constant";
import Breadcrumb from "../../Components/Breadcrumb";
import { pageSectionSchema } from "../../Validation/Validation";
import { getFetchData } from "../../utils/apiUtils";
import CodeEditor from "../../Components/CodeEditor";

const AddPageSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pageId } = useParams();
  const editData = location.state;
  const editingId = editData?._id;
  const [cmsData, setCmsData] = useState([]);
  const [moduleData, setModuleData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCmsData = () =>
    getFetchData({
      url: "cms/getallcms",
      setGetData: setCmsData,
    });
  const fetchModuleData = () =>
    getFetchData({
      url: "module/getmodule",
      setGetData: setModuleData,
    });

  useEffect(() => {
    fetchCmsData();
    fetchModuleData();
  }, []);

  const cmsOptions = cmsData.map((item) => ({
    label: `${item.title}`,
    value: item._id,
    type: "CMS",
  }));

  const moduleOptions = moduleData.map((item) => ({
    label: item.name,
    value: item._id,
  }));

  const initialValues = {
    pageBuilderId: pageId,
    sortOrder: editData?.sortOrder || "",
    type: editData?.type || "",
    cmsId: editData?.cmsId?._id || null,
    moduleId: editData?.moduleId?._id || null,
    heading: editData?.heading || "",
    title: editData?.title || "",
    subTitle: editData?.subTitle || "",
  };

  const { values, setFieldValue, handleSubmit, touched, errors, handleChange } = useFormik({
    initialValues,
    validationSchema: pageSectionSchema,
    onSubmit: async (vals) => {
      try {
        setLoading(true);

        const response = editingId
          ? await axiosInstance.put(`pagesection/update/${editingId}`, vals)
          : await axiosInstance.post("pagesection/create", vals);

        toast.success(response.data.message);
        navigate(`/page-section/${pageId}`);
      } catch (err) {
        toast.error(err?.response?.data?.message || "Error");
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Page Builder", path: "/page-builder" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  const MenuType = [
    { label: "CMS", value: "CMS" },
    { label: "Module", value: "Module" },
  ];

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3>{editingId ? "Update" : "Add"} Page Section</h3>
        <Breadcrumb items={breadcrumbdata} />
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row px-3">
              <div className="col-sm-4">
                <label className="col-form-label ">Sort Order</label>
                <input
                  type="number"
                  className="form-control"
                  value={values.sortOrder}
                  onChange={(e) => setFieldValue("sortOrder", e.target.value)}
                />
                <div className="text-danger mt-1">{errors.sortOrder}</div>
              </div>


              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="menu-type" className="col-form-label ">
                    Select Type
                  </label>
                  <Select
                    placeholder="Select Type"
                    isClearable
                    styles={customStyles}
                    options={MenuType}
                    value={
                      MenuType.find((opt) => opt.value === values.type) || null
                    }
                    onChange={(option) =>
                      setFieldValue("type", option ? option.value : null)
                    }
                    name="type"
                  />
                  {touched.type && errors.type && (
                    <small className="text-danger">{errors.type}</small>
                  )}
                </div>
              </div>


              {values.type === "CMS" && (
                <div className="col-sm-4">
                  <div className="form-group">
                    <label htmlFor="menu-type" className="col-form-label ">
                      CMS Name
                    </label>
                    <Select
                      placeholder="Select CMS"
                      isClearable
                      styles={customStyles}
                      options={cmsOptions}
                      value={
                        cmsOptions.find((opt) => opt.value === values.cmsId) ||
                        null
                      }
                      onChange={(option) =>
                        setFieldValue("cmsId", option ? option.value : null)
                      }
                      name="cmsId"
                    />
                    {touched.cmsId && errors.cmsId && (
                      <small className="text-danger">{errors.cmsId}</small>
                    )}
                  </div>
                </div>
              )}

              {values.type === "Module" && (
                <div className="col-sm-4">
                  <div className="form-group">
                    <label className="col-form-label">Select Module</label>

                    <Select
                      placeholder="Select Module"
                      isClearable
                      styles={customStyles}
                      options={moduleOptions}
                      value={
                        moduleOptions.find(
                          (opt) => opt.value === values.moduleId,
                        ) || null
                      }
                      onChange={(option) =>
                        setFieldValue("moduleId", option ? option.value : null)
                      }
                      name="moduleId"
                    />

                    {touched.moduleId && errors.moduleId && (
                      <small className="text-danger">{errors.moduleId}</small>
                    )}
                  </div>
                </div>
              )}

              {
                values.type === "Module" && (
                  <>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="heading" className="col-form-label ">
                          Heading
                        </label>
                        <input
                          type="text"
                          className="form-control border border-dark"
                          id="heading"
                          name="heading"
                          placeholder="Enter heading"
                          value={values.heading}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="title" className="col-form-label ">
                          Title
                        </label>
                        <CodeEditor
                          value={values.title}
                          onChange={(val) => setFieldValue("title", val)}
                        />
                        {touched.title && errors.title && (
                          <small className="text-danger">{errors.title}</small>
                        )}
                      </div>
                    </div>


                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="subTitle" className="col-form-label ">
                          Sub Title
                        </label>
                        <CodeEditor
                          value={values.subTitle}
                          onChange={(val) => setFieldValue("subTitle", val)}
                        />
                        {touched.subTitle && errors.subTitle && (
                          <small className="text-danger">{errors.subTitle}</small>
                        )}
                      </div>
                    </div>
                  </>
                )}
              <div
                className="d-flex justify-content-center mt-4"
                style={{ width: "100%" }}
              >
                <Button type="submit" color="primary" disabled={loading}>
                  {loading ? (
                    <span className="d-inline-flex align-items-center gap-2">
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Processing...
                    </span>
                  ) : (
                    "Save"
                  )}
                </Button>

                <Link to={`/page-section/${pageId}`}>
                  <Button color="danger mx-2">Cancel</Button>
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPageSection;
